import { useEffect, useState } from "react";
import bibtexParse from "bibtex-parse-js";

function parseBibFile(jsonText) {
  return jsonText.map((entry) => ({
    id: entry.citationKey,
    type: entry.entryType,
    title: entry.entryTags.title || "",
    affiliated: entry.entryTags.affiliated || "",
    department: entry.entryTags.department || "",
    organization: entry.entryTags.organization || "",
    period: entry.entryTags.period.split("~").map((str)=>(str.trim().split(".").map((str2)=>str2.trim()))) || ""
  }));
}

function BibEntry({ entry }) {
  return (
    <div className="bibentry">
        <ul>
            <li>
                <strong>{entry.title}</strong>.&nbsp;
                <i>
                    {entry.affiliated}&nbsp;
                    @{entry.department?<span>{entry.department}, </span>:""}
                    {entry.organization?<span>{entry.organization}, </span>:""}
                    {entry.period.map((str)=>(str.join(". "))).join(" ~ ")}
                </i>
            </li>
        </ul>
    </div>
  );
}

function BibList({ entries }) {
  if (!entries.length) return <p className="text-gray-500">불러오는 중...</p>;
  const mon = [/^Jan$/, /^Feb$/, /^Mar$/, /^Apr$/, /^May$/, /^Jun$/, /^Jul$/, /^Aug$/, /^Sep$/, /^Oct$/, /^Nov$/, /^Dec$/];
  const Mon = (str) => {
    for(var i=0; i<12; ++i) if(mon[i].test(str)) return i;
    return -1;
  };
  const sorted = [...entries].sort((a, b) => {
    return ((a.period.at(-1)[1] || 0) === (b.period.at(-1)[1] || 0)
    ?(Mon(b.period.at(-1)[0]) || 0) - (Mon(a.period.at(-1)[0]) || 0)
    :(b.period.at(-1)[1] || 0) - (a.period.at(-1)[1] || 0)
  )});

  return (
    <div>
      {sorted.map((entry) => (
        <BibEntry key={entry.id} entry={entry} />
      ))}
    </div>
  );
}

export default function WorkExp() {
    const [works, setWorks] = useState([]);

    useEffect(() => {
    async function loadBib() {
        try {
        const response = await fetch("/Data/work.bib");
        const text = await response.text();
        const jsonText = bibtexParse.toJSON(text);
        var worklist = [];
        jsonText.forEach((cur, idx, arr) =>{
            if(cur.entryType === 'work') worklist.push(cur);
        });
        setWorks(parseBibFile(worklist));
        } catch (error) {
            console.error("Failed to load BibTeX:", error);
        }
    }
    loadBib();
    }, []);
    return(
        <div className = "WorkExp">
            <h2>
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="briefcase" className="svg-inline logo_hsize" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"></path></svg>
              Work Experience
            </h2>
            <BibList entries={works} />
        </div>
    );
}